/* eslint-disable max-classes-per-file */
import {
  ProfileHeader,
  ProfileTreatment,
  ProfileDetails,
  ProfileAEO,
  RiskHeader,
  ProfileScheduler,
  Indicator,
} from "../interface/ui-intelligencemgmt.interface";

export class AddRiskHeader {
  static readonly type = "[RiskHeader] AddRiskHeader";
  constructor(public payload: RiskHeader, public optype: string) {}
}

export class resetInformationId {
  static readonly type = "[InformationId] resetInformationId";
}

export class UpdateRiskHeader {
  static readonly type = "[RiskHeader] UpdateRiskHeader";
  constructor(
    public payload: RiskHeader,
    public optype: string,
    public Id: string
  ) {}
}

export class LoadSchema {
  static readonly type = "[LoadSchema] Schema";
}

export class getRiskInfo {
  static readonly type = "[RiskHeader] getRiskInfo";
  constructor(public riskId: string) {}
}

export class resetRiskInfo {
  static readonly type = '[Risk] Reset Risk Info';
}

export class setInformationId {
  static readonly type = "[informationId] setInformationId";
  constructor(public payload: number) {}
}

export class setTabIndex {
  static readonly type = "[TabIndex] setTabIndex";
  constructor(public payload: number) {}
}
export class setProfileId {
  static readonly type = "[profileId] setProfileId";
  constructor(public payload: number) {}
}
export class AddProfileHeader {
  static readonly type = "[ProfileHeader] AddProfileHeader";
  constructor(public payload: ProfileHeader, public operationType: string) {}
}
export class UpdateProfile {
  static readonly type = "[UpdateProfile] UpdateProfile";
  constructor(public payload: number) {}
}

export class UpdateProfileHeader {
  static readonly type = "[ProfileHeader] UpdateProfileHeader";
  constructor(
    public payload: ProfileHeader,
    public profileId: number,
    public operationType: string,
    public isDraft?: boolean
  ) {}
}
export class getProfileHeader {
  static readonly type = "[ProfileHeader] getProfileHeader";
  constructor(public profileId: number) {}
}

export class AddProfileDetail {
  static readonly type = "[ProfilDetail] AddProfileDetail";
  constructor(public payload: ProfileDetails, public pid: number) {}
}
export class UpdateProfileDetail {
  static readonly type = "[ProfilDetail] UpdateProfileDetail";
  constructor(
    public payload: ProfileDetails,
    public pid: number,
    public operationType: string
  ) {}
}
export class AddTreatmentDetail {
  static readonly type = "[ProfileTreatment] AddTreatmentDetail";
  constructor(public payload: ProfileTreatment, public pid: number) {}
}
export class UpdateTreatmentDetail {
  static readonly type = "[ProfileTreatment] UpdateTreatmentDetail";
  constructor(
    public payload: ProfileTreatment,
    public pid: number,
    public operationType: string
  ) {}
}
export class AddSchedulerDetail {
  static readonly type = "[ProfileScheduler] AddSchedulerDetail";
  constructor(public payload: ProfileScheduler, public pid: number) {}
}
export class UpdateSchedulerDetail {
  static readonly type = "[ProfileScheduler] UpdateSchedulerDetail";
  constructor(
    public payload: ProfileScheduler,
    public pid: number,
    public operationType: string
  ) {}
}

export class AddAeoDetail {
  static readonly type = "[ProfileAEO] AddAeoDetail";
  constructor(
    public payload: ProfileAEO[],
    public pid: number,
    public save: boolean
  ) {}
}
export class UpdateAeoDetail {
  static readonly type = "[ProfileAEO] UpdateAeoDetail";
  constructor(
    public payload: ProfileAEO[],
    public pid: number,
    public operationType: string,
    public save: boolean
  ) {}
}

export class LoadRdmRefValue {
  static readonly type = "[RefType] LoadRdmRefValue";
}

export class LoadClassIndicators {
  static readonly type = "[string] ClassIndicators";
}

export class SetRiskStatus {
  static readonly type = "[Risk] SetRiskStatus";
  constructor(public status: string) {}
}